<div class="valuation-events-title">
  <h1>{{'raci.treeListView.valuationEvents' | translate}}</h1>
</div>
<div>
  <div class="parent-item" *ngFor="let dataItem of data">
    <div class="parent-item-header"
         [ngClass]="{'active-event': dataItem.oid === activeOid}">
      <svg-icon src='./assets/icons/Val_Portfolios_icon.svg'
                alt="VALUATION PORTFOLIO"
                class="raci-icon parent-item-icon-white svg-icon-white"
                align='center'>
      </svg-icon>
      <h4 class="parent-item-title" (click)="setActive($event, dataItem)">{{dataItem?.parent?.name?.toUpperCase()}}</h4>
    </div>
    <div *ngIf="dataItem?.children?.length > 0" class="parent-child-body">
      <div class="parent-child" *ngFor="let child of dataItem.children"
            [ngClass]="{'active-child': child.oid === activeOid}">
        <svg-icon src='./assets/icons/Val_Portfolios_icon.svg'
                  alt="VALUATION PORTFOLIO"
                  class="raci-icon parent-item-icon-white svg-icon-white"
                  align='center'>
        </svg-icon>
        <h4 class="parent-child-title" (click)="setActive($event, child)">{{child?.name?.toUpperCase()}}</h4>
      </div>
    </div>
  </div>
</div>
